module.exports = __webpack_public_path__ + "static/assets/89b23cdaf4cd793344e503007bd3b405.gif";